import axios from "@/util/axios";

const PREFIX_URI = "/basedata/product/warehouse";

export default {
    /** 分页查询仓库列表 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data}),
    /** 保存仓库 */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data}),
    /** 删除仓库 */
    delete: (id) => axios.del({url: `${PREFIX_URI}/delete`, data: {id}}),
    /** 启用/停用仓库 */
    updateStatus: (id, status) => axios.get({url: `${PREFIX_URI}/updateStatus`, data: {id, status}}),
    /** 查询部门树 */
    queryDepartList: () => axios.get({url: `${PREFIX_URI}/queryDepartList`}),
}
